export const trimSpacesSQL = (field: string) => `REPLACE(${field}, ' ', '')`;
export const trimSpaces = (query: string) => query.replace(/[  ]/g, '');
